export const emailRouting = {
  pageTitle: 'Email Provider Routing',
  defaultProvider: 'Default provider',
  defaultProviderHelp: 'Used when a template is set to "Use default".',
  mailgunNotConfigured:
    'Mailgun is not configured in this environment. Set MAILGUN_API_KEY and MAILGUN_DOMAIN to enable it.',
  resendNotConfigured:
    'Resend is not configured in this environment. Set RESEND_API_KEY to enable it.',
  col: {
    template: 'Template',
    category: 'Category',
    recipient: 'Recipient',
    provider: 'Provider',
    enabled: 'Enabled',
    updated: 'Last updated',
    test: 'Test',
  },
  status: {
    notImplementedBadge: 'NOT IMPLEMENTED',
    notImplementedNote:
      'This template is registered but no production code path sends it yet. Toggling the provider here has no effect until the trigger is wired up.',
  },
  test: {
    button: 'Send test',
    dialogTitle: 'Send test email',
    helperText:
      'A real email will be dispatched to the address below using the provider currently configured for this template. Sample data is used for the template variables.',
    recipientEmail: 'Recipient email address',
    language: 'Language',
    send: 'Send test email',
    sending: 'Sending…',
    cancel: 'Cancel',
    invalidEmail: 'Enter a valid email address.',
    sendSucceeded: 'Test email queued for delivery to %{email}.',
    sendFailed: 'Failed to send test email',
    disabledHint: 'Enable this template before sending a test email.',
  },
  customer: 'Customer',
  admin: 'Admin',
  useDefault: 'Use default (%{default})',
  saveAll: 'Save all changes',
  discard: 'Discard',
  saving: 'Saving…',
  saveSucceeded: 'Email routing updated',
  saveFailed: 'Failed to save email routing',
  loadFailed: 'Failed to load email routing',
};
